export default __webpack_public_path__ + "static/media/bg.min.2fb64b98.jpg";